import { baseUrl } from "src/utils/url-utils";
import { OpenAPIConfig, OpenAPI as OpenAPIV1 } from "./openapi/v1";
import { hasValueAndNotEmpty } from "@itk/typescript-utils";
import { itkComponentsButtonActions, setOverlayedFetchConfig } from "@itk/mui-components";
import { Store } from "redux";
import { store } from "src/store";

export const setAccessToken = (accessToken: string) => {
  localStorage.setItem("deko-access-token", accessToken);
  configureOpenApis();
};

export const getAccessToken = () => {
  const state = store.getState();

  const tokenLoading = state.generalReducer.authorizationGateReducer.authorizationGateState;
  if (tokenLoading.loading === "has-loaded") {
    return tokenLoading.data.access_token;
  }

  const accessToken = localStorage.getItem("deko-access-token");

  if (hasValueAndNotEmpty(accessToken)) {
    deleteAccessToken();
  }

  return accessToken ?? "";
};

export const deleteAccessToken = () => {
  localStorage.removeItem("deko-access-token");
};

// Resolves the custom headers required on every API call from current Redux state.
// Must never throw and must never block, since it runs on every request including
// ones fired before customer/contact data has loaded (e.g. initial bootstrap calls).
// Header keys are omitted entirely when data isn't ready yet, rather than sent as
// empty strings, because the generated request layer only strips `undefined` values -
// an empty string would still be sent as a real (but meaningless) header value.
// x-origin is not sent here - deko-x-public-backend asserts it itself when calling
// deko-x-backend and never reads it from the inbound request, so sending it from here
// was always dead data.
const getCustomHeaders = async (): Promise<Record<string, string>> => {
  const state = store.getState();
  const headers: Record<string, string> = {};

  const currentCustomer = state.generalReducer.applicationReducer.currentCustomer;
  if (currentCustomer.loading === "has-loaded" && hasValueAndNotEmpty(currentCustomer.data.customerId)) {
    headers["x-customerId"] = currentCustomer.data.customerId;
  }

  return headers;
};

const configureOpenApi = (openApi: OpenAPIConfig) => {
  openApi.BASE = baseUrl as string;
  openApi.TOKEN = async () => getAccessToken();
  openApi.HEADERS = getCustomHeaders;
};

export const configureOpenApis = () => {
  configureOpenApi(OpenAPIV1);
};

export const configureUiBlock = (store: Store) => {
  const beforeCallAction = (url: string, reject?: (error?: string) => void) => store.dispatch(itkComponentsButtonActions.addOngoingCall(url, reject));
  const afterCallAction = (url: string) => store.dispatch(itkComponentsButtonActions.removeOngoingCall(url));

  OpenAPIV1.BEFORE_CALL_ACTION = beforeCallAction;
  OpenAPIV1.AFTER_CALL_ACTION = afterCallAction;

  setOverlayedFetchConfig({ beforeCallAction, afterCallAction });
};
